import accounting from 'accounting';
import { FormGroup, HorizontalRule, Table } from 'arag-ui-lib';
import { CURRENCY } from '../../../helpers/variables';
import StagesDescription from './stagesDescription';

const StagedStep4 = (props) => {
  const {
    stagesSubSettings,
    stagedPremiumData,
    isApplicationPremium,
    amountColumnsDisplayDataPerStage,
  } = props;

  const stagesColumns = [
    {
      propertyName: 'stageName',
      header: 'Stage of Policy',
      sortable: false,
      id: 'stageName',
      formatter: (v) => {
        return <span> {v.stageName}</span>;
      },
    },
    {
      propertyName: 'fields',
      header: 'Amounts',
      sortable: false,
      id: 'fields',
      formatter: (v) => {
        return amountColumnsDisplayDataPerStage(v).map((c) => {
          return (
            <div key={c.title}>
              <FormGroup
                labelSize={'col-sm-6'}
                inputSize={'col-sm-6'}
                label={c.title}
                variant={'plain'}
                inputProps={{
                  label: accounting.formatMoney(c.value, `${CURRENCY} `, 2),
                }}
              />
              <HorizontalRule variant="pale" />
            </div>
          );
        });
      },
    },
  ];
  const mappedStages = stagesSubSettings != undefined ? stagesSubSettings : [];
  return (
    <div>
      {isApplicationPremium == false && (
        <FormGroup
          labelSize="col-sm-4"
          inputSize="col-sm-6"
          label="Valid from"
          variant="plain"
          inputProps={{
            label: stagedPremiumData.validFrom
              ? new Date(stagedPremiumData.validFrom).toLocaleDateString(
                  'en-GB'
                )
              : '',
          }}
        />
      )}
      {isApplicationPremium == false && (
        <FormGroup
          labelSize="col-sm-4"
          inputSize="col-sm-6"
          label="Valid until"
          variant="plain"
          inputProps={{
            label: stagedPremiumData.validUntil
              ? new Date(stagedPremiumData.validUntil).toLocaleDateString(
                  'en-GB'
                )
              : '',
          }}
        />
      )}
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Notes"
        variant="plain"
        inputProps={{ label: stagedPremiumData?.notes }}
      />
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Comments"
        variant="plain"
        inputProps={{ label: stagedPremiumData?.comments }}
      />
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Coverage Types"
        variant="plain"
        inputProps={{ label: stagedPremiumData?.coverageOptionName }}
      />
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Deductibles"
        variant="plain"
        inputProps={{ label: stagedPremiumData?.deductibleOptionName }}
      />
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Endorsements"
        variant="plain"
        inputProps={{ label: stagedPremiumData?.endorsementOptionName }}
      />
      <FormGroup
        labelSize="col-sm-4"
        inputSize="col-sm-6"
        label="Average Expected Premium"
        variant="plain"
        inputProps={{
          label: accounting.formatMoney(stagedPremiumData?.averageExpectedPremium, `${CURRENCY} `, 2),
          }}
      />
      <HorizontalRule />
      <div>
        <Table
          orderAsc={false}
          striped
          columns={stagesColumns}
          data={mappedStages}
        />
      </div>
      <StagesDescription />
    </div>
  );
};
export default StagedStep4;
